 // Add z-index when cart icon is clicked
document.querySelector('a#cart-counter').addEventListener('click', function() {
    // Add z-index to #shopify-chat
    const shopifyChat = document.querySelector('div#shopify-chat');
    if (shopifyChat) {
        shopifyChat.style.zIndex = '9';
    }

    // Add z-index to inbox-online-store-chat#ShopifyChat
    const inboxChat = document.querySelector('inbox-online-store-chat#ShopifyChat');
    if (inboxChat) {
        inboxChat.style.zIndex = '9';
    }

    // Add z-index to one-loyalty-widget
    const loyaltyWidget = document.querySelector('.Avada-Joy_ButtonWidget');
    if (loyaltyWidget) {
        loyaltyWidget.style.zIndex = '9';
    }
});

// Remove z-index when close cart button is clicked
document.querySelector('button.cart-drawer__close').addEventListener('click', function() {
    // Reset z-index to default for #shopify-chat
    const shopifyChat = document.querySelector('div#shopify-chat');
    if (shopifyChat) {
        shopifyChat.style.zIndex = ''; // Removes inline zIndex
    }

    // Reset z-index for inbox-online-store-chat#ShopifyChat
    const inboxChat = document.querySelector('inbox-online-store-chat#ShopifyChat');
    if (inboxChat) {
        inboxChat.style.zIndex = '2147483646'; // Removes inline zIndex
    }

    // Reset z-index for one-loyalty-widget
    const loyaltyWidget = document.querySelector('.Avada-Joy_ButtonWidget');
    if (loyaltyWidget) {
        loyaltyWidget.style.zIndex = '2147483646'; // Removes inline zIndex
    }
});

// Remove z-index when div#CartDrawer display is set to none
const cartDrawer = document.querySelector('a#cart-counter');
if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'style' && cartDrawer.style.display === 'none') {
                // Reset z-index for #shopify-chat
                const shopifyChat = document.querySelector('div#shopify-chat');
                if (shopifyChat) {
                    shopifyChat.style.zIndex = ''; // Removes inline zIndex
                }

                // Reset z-index for inbox-online-store-chat#ShopifyChat
                const inboxChat = document.querySelector('inbox-online-store-chat#ShopifyChat');
                if (inboxChat) {
                    inboxChat.style.zIndex = '2147483646'; // Removes inline zIndex
                }

                // Reset z-index for one-loyalty-widget
                const loyaltyWidget = document.querySelector('.Avada-Joy_ButtonWidget');
                if (loyaltyWidget) {
                    loyaltyWidget.style.zIndex = '2147483646'; // Removes inline zIndex
                }
            }
        });
    });

    // Observe changes to the style attribute of div#CartDrawer
    observer.observe(cartDrawer, { attributes: true });
}